import { render, staticRenderFns } from "./VigilancePage.vue?vue&type=template&id=0629c6ae&scoped=true"
import script from "./VigilancePage.vue?vue&type=script&lang=js"
export * from "./VigilancePage.vue?vue&type=script&lang=js"
import style0 from "./VigilancePage.vue?vue&type=style&index=0&id=0629c6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629c6ae",
  null
  
)

export default component.exports